import { toast } from 'sonner';
import { useUpdateApplication } from './useUpdateApplication';
import { useUnlinkConfirmation, type ConfirmUnlinkState } from './useUnlinkConfirmation';
import type { ApplicationStatus } from '../types/jobPositionCandidate.types';

export type { ConfirmUnlinkState };

export interface UseJobPositionCandidateActionsReturn {
  handleStatusChange: (candidateId: string, newStatus: ApplicationStatus) => void;
  handleUnlinkClick: (candidateId: string, candidateName: string) => void;
  handleConfirmUnlink: () => void;
  confirmUnlink: ConfirmUnlinkState;
  setConfirmUnlink: (s: ConfirmUnlinkState) => void;
  isBusy: boolean;
}

export function useJobPositionCandidateActions(
  positionId: string
): UseJobPositionCandidateActionsReturn {
  const { updateApplication, isLoading: isUpdating } = useUpdateApplication();
  const { isUnlinking, ...unlink } = useUnlinkConfirmation(positionId);
  const handleStatusChange = (candidateId: string, newStatus: ApplicationStatus): void => {
    updateApplication(
      { positionId, candidateId, data: { applicationStatus: newStatus } },
      {
        onSuccess: () => toast.success('Status updated successfully'),
        onError: () => toast.error('Failed to update status'),
      }
    );
  };
  return {
    handleStatusChange,
    ...unlink,
    isBusy: isUpdating || isUnlinking,
  };
}
